const Menu =  [
  { header: 'Reembolso' },
  {
    title: 'Relatórios',
    icon: 'file_copy',
    name: 'relatorios',
  },
  { header: 'Configurações' },
  {
    title: 'Administrativo',
    group: 'admin',
    icon: 'settings',
    items: [
      { name: "usuarios", title: "Usuários", component: "usuarios" },
      { name: "categorias", title: "Categorias", component: "categorias" },
    ]
  }
];
// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;
